var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"error-wrap",on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.error.message)+" ")]):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }